export default __webpack_public_path__ + "static/media/sparkles.3464d8a6.svg";